export const defaultFontTokens = {
    lightFontFamily: 'Poppins-Light',
    regularFontFamily: 'Poppins-Regular',
    mediumFontFamily: 'Poppins-Medium',
    semiboldFontFamily: 'Poppins-Semibold',
    boldFontFamily: 'Poppins-Bold',
};
export default (fontTokens = defaultFontTokens) => {
    const header1 = {
        fontFamily: fontTokens.semiboldFontFamily,
        fontSize: '36px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const header2 = {
        fontFamily: fontTokens.semiboldFontFamily,
        fontSize: '24px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const header3 = {
        fontFamily: fontTokens.regularFontFamily,
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const header4 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const headerBold1 = {
        fontFamily: fontTokens.semiboldFontFamily,
        fontSize: '36px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const headerBold2 = {
        fontFamily: fontTokens.semiboldFontFamily,
        fontSize: '24px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const headerBold3 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const body1 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const body2 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const body3 = {
        fontFamily: fontTokens.regularFontFamily,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const bodyLight3 = {
        fontFamily: fontTokens.lightFontFamily,
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const bodyMedium3 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const bodyMedium1 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const bodyBold2 = {
        fontFamily: fontTokens.boldFontFamily,
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: 1.2,
        letterSpacing: 'auto',
    };
    const button1 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 'inherit',
        letterSpacing: '0.32px',
    };
    const button2 = {
        fontFamily: fontTokens.mediumFontFamily,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 'inherit',
        letterSpacing: '0.32px',
    };
    return {
        header1,
        header2,
        header3,
        header4,
        headerBold1,
        headerBold2,
        headerBold3,
        body1,
        body2,
        body3,
        bodyMedium3,
        bodyMedium1,
        bodyLight3,
        bodyBold2,
        button1,
        button2,
    };
};
//# sourceMappingURL=typography.js.map